import React, { useState } from "react";
import "./QAChatbot.css";

function QAChatbot() {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const askQuestion = async () => {
    if (!question.trim()) return;

    setLoading(true);
    setAnswer("");

    try {
      const response = await fetch(
        "https://qa-ai-platform-backend.onrender.com/api/qa-chatbot",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ question }),
        }
      );

      const data = await response.json();
      setAnswer(data.answer || "No response received.");
    } catch (err) {
      console.error(err);
      setAnswer("Failed to get answer.");
    }

    setLoading(false);
  };

  return (
    <div className="chatbot-container">
      <h1>🤖 QA Chatbot</h1>
      <p>Ask anything about testing, SQL, APIs, automation, frameworks.</p>

      <textarea
        className="chatbot-input"
        placeholder="Example: Explain Page Object Model with example"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
      />

      <button onClick={askQuestion} disabled={loading}>
        {loading ? "Thinking..." : "Ask Question"}
      </button>

     {answer && (
    <div className="chatbot-response">
    {answer}
    </div>
    )}

    </div>
  );
}

export default QAChatbot;
